// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__25KpD","list":"styles_list__1zZoE"};